import React from 'react';
export function FAQSection() {
  const faqs = [{
    q: '¿Cómo recibo el contenido? ¿Me llega algo por correo?',
    a: 'Todo es digital y acceso inmediato. Apenas realizás tu pago, recibís un email con el link de acceso. En minutos podés estar viendo tu primer diseño desde el celular, tablet o computadora — sin esperar nada.'
  }, {
    q: '¿Sirve si nunca hice gelatinas o no sé cocinar bien?',
    a: 'Es exactamente para vos. El método fue diseñado para principiantes absolutas. Cada paso está explicado desde cero, sin dar nada por sentado. Si podés seguir instrucciones, podés hacer estos diseños.'
  }, {
    q: '¿Es pago único o tiene cuota mensual?',
    a: 'Pago único de $14.999 ARS y listo. Acceso de por vida a todo el contenido, incluyendo actualizaciones futuras. Sin suscripciones, sin cargos automáticos, sin sorpresas.'
  }];
  return <section className="bg-bg py-16 px-5" data-id="element-30">
      <div className="container-custom" data-id="element-31">
        <span className="section-tag text-center mx-auto" data-id="element-32">
          Preguntas frecuentes
        </span>
        <h2 className="section-title text-center mb-7" data-id="element-33">ÚLTIMAS DUDAS</h2>

        <div className="max-w-[640px] mx-auto flex flex-col gap-3.5" data-id="element-34">
          {faqs.map((faq, idx) => <div key={idx} className="bg-card border border-border rounded-[10px] p-[22px_24px]" data-id="element-35">
              <h4 className="text-[15px] font-bold text-white mb-2 flex items-start gap-2.5" data-id="element-36">
                <span className="text-pink text-[18px] shrink-0" data-id="element-37">?</span>
                {faq.q}
              </h4>
              <p className="text-[14px] text-muted leading-[1.6] pl-7" data-id="element-38">
                {faq.a}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}